import axios from './axios'

/**
 * 获取信息
 * risk_level: high | middle | low
 * start_date: 2023-03-24
 * end_date: 2023-03-30
 */
export const getRiskPhoneData = (params) => {
  return axios({
    url: '/user/self/usage-statistic/phone/online/stat/',
    method: 'GET',
    params
  })
}

/**
 * 表格导出
 */
export const exportRiskPhone = (params) => {
  return axios({
    url: '/user/self/usage-statistic/phone/online/stat/export/',
    method: 'GET',
    params
  })
}